// src/components/Navigation/RouteConfig.jsx
import { Routes, Route } from 'react-router-dom';
import { ROUTES } from './routes';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

// Page imports
import { Navigate } from 'react-router-dom';
import Home from '../../pages/Home';
import About from '../../pages/About';
import Services from '../../pages/services';
import Playground from '../../pages/Playground';
import Resources from '../../pages/Resources';
import ResourceDetail from '../../pages/ResourceDetail';
import AuthCallback from '../../pages/AuthCallback';
import Login from '../../pages/Login';
import Register from '../../pages/Register';
import ForgotPassword from '../../pages/ForgotPassword';
import ResetPassword from '../../pages/ResetPassword';
import EmailVerification from '../../pages/EmailVerification';
import AppsPage from '../../pages/AppsPage';
import GameLibrary from '../../pages/GameLibrary';
import AECLibrary from '../../pages/AECLibrary';
import AECCompare from '../../pages/AECCompare';
import AECToolDetail from '../../pages/AECToolDetail';
import AECConsulting from '../../pages/AECConsulting';
import StreamingSession from '../../pages/StreamingSession';
import Profile from '../../pages/Profile';
// POCs
import Game2048 from '../../pages/GameFiles/A/puzzle';
import MemoryMatch from '../../pages/GameFiles/A/Memory'; // or your new path
import XOGame from '../../pages/GameFiles/A/Tictac';
import SudokuGame from '../../pages/GameFiles/A/Sudoku';
import SuccessPage from '../../pages/SuccessPage';
import LandingPage from '../../pages/LandingPage';
import ChessGame from '../../pages/GameFiles/A/chess';
// Apps
import Forecasting from '../../pages/GameFiles/POC/Forecasting';
import PropertyPro from '../../pages/PropertyPro';
import TailArena from '../../pages/GameFiles/POC/TailArena';
import ForecastApp from '../../pages/ForecastApp';
// Industry Solutions
import Fintech from '../../pages/IndustrySol/Fintech';
import ConstructionTech from '../../pages/IndustrySol/ConstructionTech';
import CreativeIndustries from '../../pages/IndustrySol/CreativeIndustries';
// Case studies
import CaseStudy1 from '../../pages/CaseStudies/CaseStudy1';
import CaseStudy2 from '../../pages/CaseStudies/CaseStudy2';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import CookiePolicy from '../../pages/CookiePolicy';
import Terms from '../../pages/Terms';
// InviteApp
import {
  InviteHome,
  TemplateSelect as InviteTemplateSelect,
  CreateInvite,
  Preview as InvitePreview,
  Send as InviteSend,
  InviteView,
} from '../../pages/InviteApp';

const RouteConfig = () => {
  return (
    <Routes>
      {/* ✅ Public marketing pages – accessible even when logged in */}
      <Route path={ROUTES.HOME} element={<Home />} />
      <Route path={ROUTES.About} element={<About />} />
      <Route path={ROUTES.Services} element={<Services />} />
      <Route path={ROUTES.CONTACT} element={<AECConsulting />} />
      <Route path={ROUTES.RESOURCES}                   element={<Resources />} />
      <Route path={ROUTES.RESOURCES_ARTICLES}           element={<Resources />} />
      <Route path={ROUTES.RESOURCES_CASE_STUDIES}       element={<Resources />} />
      <Route path={ROUTES.RESOURCES_INDUSTRY_SOLUTIONS} element={<Resources />} />
      <Route path={ROUTES.RESOURCES_DETAIL}             element={<ResourceDetail />} />
      <Route path={ROUTES.Playground} element={<Playground />} />
      <Route path={ROUTES.LandingPage} element={<LandingPage />} />

      {/* Industry Solution Pages */}
      <Route path={ROUTES.FINTECH} element={<Fintech />} />
      <Route path={ROUTES.CONSTRUCTION_TECH} element={<ConstructionTech />} />
      <Route path={ROUTES.CREATIVE_INDUSTRIES} element={<CreativeIndustries />} />

      {/* Case Study Pages */}
      <Route path={ROUTES.CASESTUDY1} element={<CaseStudy1 />} />
      <Route path={ROUTES.CASESTUDY2} element={<CaseStudy2 />} />

      {/* InviteApp Routes */}
      <Route path={ROUTES.INVITEAPP_HOME} element={<InviteHome />} />
      <Route path={ROUTES.INVITEAPP_VIEW} element={<InviteView />} />
      <Route
        path={ROUTES.INVITEAPP_TEMPLATES}
        element={
          <ProtectedRoute>
            <InviteTemplateSelect />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.INVITEAPP_CREATE}
        element={
          <ProtectedRoute>
            <CreateInvite />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.INVITEAPP_PREVIEW}
        element={
          <ProtectedRoute>
            <InvitePreview />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.INVITEAPP_SEND}
        element={
          <ProtectedRoute>
            <InviteSend />
          </ProtectedRoute>
        }
      />

      {/* Legal pages */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy"  element={<CookiePolicy />} />
      <Route path="/terms"          element={<Terms />} />

      {/* ✅ Auth routes – only these go through PublicRoute */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path={ROUTES.REGISTER}
        element={
          <PublicRoute>
            <Register />
          </PublicRoute>
        }
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<EmailVerification />} />

      {/* Auth callback */}
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* ✅ Free Games – **no guards**, anyone can open them if they know the URL */}
      <Route path="/games/2048" element={<Game2048 />} />

      {/* 🔥 IMPORTANT: fix XOGame path to match your navigate() calls */}
      <Route path="/games/XOGame" element={<XOGame />} />

      <Route path="/games/MemoryMatch" element={<MemoryMatch />} />
      <Route path="/games/SudokuGame" element={<SudokuGame />} />
      <Route path="/games/chess" element={<ChessGame />} />

      {/* Apps */}
      <Route path="/apps/forecasting" element={<Forecasting />} />
      <Route path="/apps/propertypro" element={<PropertyPro />} />
      <Route path="/apps/tailarena" element={<TailArena />} />
      <Route path="/apps/forecast-demo" element={<ForecastApp />} />

      {/* ── Apps hub (nested) ── */}
      <Route path={ROUTES.APPS} element={<AppsPage />}>
        <Route index element={<Navigate to={ROUTES.APPS_AEC} replace />} />
        <Route path="aec-tools"    element={<AECLibrary />} />
        <Route path="custom-tools" element={<GameLibrary />} />
      </Route>

      {/* AEC detail pages live outside the hub (full-page views) */}
      <Route path={ROUTES.LIBRARY_AEC_COMPARE}      element={<AECCompare />} />
      <Route path={ROUTES.LIBRARY_AEC_COMPARE_SLUGS} element={<AECCompare />} />
      <Route path={ROUTES.LIBRARY_AEC_TOOL}          element={<AECToolDetail />} />

      {/* Legacy redirects — keep old bookmarks working */}
      <Route path={ROUTES.GAME_LIBRARY}     element={<Navigate to={ROUTES.APPS_CUSTOM} replace />} />
      <Route path={ROUTES.LIBRARY_CUSTOM}   element={<Navigate to={ROUTES.APPS_CUSTOM} replace />} />
      <Route path={ROUTES.LIBRARY_AEC}      element={<Navigate to={ROUTES.APPS_AEC}    replace />} />
      <Route path={ROUTES.CONSULTING}       element={<Navigate to={ROUTES.CONTACT} replace />} />
      <Route path={ROUTES.APPS_CONSULTING}  element={<Navigate to={ROUTES.CONTACT} replace />} />

      {/* ✅ Protected app area */}
      <Route
        path={ROUTES.STREAM}
        element={
          <ProtectedRoute>
            <StreamingSession />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.PROFILE}
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.SUCCESS}
        element={
          <ProtectedRoute>
            <SuccessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={ROUTES.CANCEL}
        element={
          <ProtectedRoute>
            <SuccessPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default RouteConfig;
